import { render, staticRenderFns } from "./overview-data.vue?vue&type=template&id=3bd1fb44&scoped=true"
import script from "./overview-data.vue?vue&type=script&lang=js"
export * from "./overview-data.vue?vue&type=script&lang=js"
import style0 from "./overview-data.vue?vue&type=style&index=0&id=3bd1fb44&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd1fb44",
  null
  
)

export default component.exports